import { SportCarousel as HPYBET } from 'sites/happybet/features/sport/components/sportCarousel/SportCarousel';
import { SportCarousel as SNAI } from 'sites/snai/features/sport/components/sportCarousel/SportCarousel';
import { SportCarouselProps } from './types';
import dynamic from 'next/dynamic';
import { isHappybetSite } from 'utility/constant';

const SITE_NAME = `${process.env.NEXT_PUBLIC_MODULE_SITE ?? 'snai'}`.toLowerCase();

export const DynamicSportCarousel = dynamic<SportCarouselProps>(() =>
  import(`sites/${SITE_NAME}/features/sport/components/sportCarousel/SportCarousel`).then((mod) => mod.SportCarousel)
);

export const SportCarousel = (props: SportCarouselProps) => (isHappybetSite ? HPYBET(props) : SNAI(props));
